import { Injectable, NgZone } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Event, ActivatedRouteSnapshot, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RoutesRecognized, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { SessionService } from './session.service';
import { filter, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TracingService extends HttpService {

  constructor(
    private router: Router,
    protected override http: HttpClient,
    protected override session: SessionService,
    protected ngZone: NgZone)
  {
    super(http,session);

    this.traceEvent("tracing started");

    if(environment.isTracingEnabled && window)
      (window as any).frontendTrace = this.traceEvent.bind(this);

    if(environment.isRoutingTraceEnabled)
      this.setupRouterTracing();
  }

  private setupRouterTracing(): void {
    this.ngZone.runOutsideAngular(() => {
      this.router.events
        .pipe(
          filter((event: Event) => true),
          tap((event: Event) => {
            const traceMessage = 'Event: ' + JSON.stringify(this.formatRouterEvent(event));
            this.ngZone.run(() => {
              this.traceEvent(traceMessage);
            });
          })
        )
        .subscribe();
    });
  }

  private formatRouterEvent(event: Event): any {
    const timestamp = new Date().toISOString();
    let eventDetails: any = {
      type: event.constructor.name,
      timestamp: timestamp,
      id: (event as any).id, // All RouterEvent types have an 'id'
      routepath: (event as any).route?.path,
      child: (event as any).route?.loadChildren
    };

    if (event instanceof NavigationStart) {
      eventDetails.url = event.url;
      eventDetails.navigationTrigger = event.navigationTrigger;
      eventDetails.restoredState = event.restoredState;
    } else if (event instanceof RoutesRecognized) {
      eventDetails.url = event.url;
      eventDetails.urlAfterRedirects = event.urlAfterRedirects;
      // You can add more details from event.state.root if needed
      // For example, to get route data:
      eventDetails.routeData = this.getRouteData(event.state.root);
    } else if (event instanceof NavigationEnd) {
      eventDetails.url = event.url;
      eventDetails.urlAfterRedirects = event.urlAfterRedirects;
      eventDetails.state = this.router.getCurrentNavigation()?.extras.state; // Capture state passed with navigate
    } else if (event instanceof NavigationCancel) {
      eventDetails.url = event.url;
      eventDetails.reason = event.reason;
    } else if (event instanceof NavigationError) {
      eventDetails.url = event.url;
      eventDetails.error = event.error ? event.error.message : 'Unknown error';
      eventDetails.stack = event.error ? event.error.stack : 'No stack trace';
    }

    return eventDetails;
  }

  private getRouteData(route: ActivatedRouteSnapshot): any {
    let data = { ...route.data };
    if (route.children) {
      route.children.forEach(child => {
        Object.assign(data, this.getRouteData(child));
      });
    }
    return data;
  }

  traceEvent(message : string){
    let timestamp = new Date().toLocaleString('en-US', { timeZone: 'Asia/Riyadh' , year : 'numeric', month : '2-digit', day: '2-digit', hour : '2-digit', minute : '2-digit', second: '2-digit', fractionalSecondDigits: 3 })
    const payload = { Message : 'Time : ' + timestamp + " | Message : " + message };
    if(environment.isTracingEnabled)
    {
      //   let headers = {
      //     type : 'application/json',
      //     Authorization: 'Bearer ' + this.session.token
      //   };
      // const blob = new Blob([ JSON.stringify(payload)], headers);
      // return this.sendBeacon(this.session.ApiUrl + 'logging/frontend-trace', blob );
      return this.doPost('logging/frontend-trace' , payload).subscribe();
    }
    return;
  }
}
